import script from "./DisplayDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayDetail.vue?vue&type=script&setup=true&lang=js"

import "./DisplayDetail.vue?vue&type=style&index=0&id=2fdb8096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fdb8096"]])

export default __exports__